// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WhyMtor_MtorQualityWrapper__YS5NZ {
  padding: 4px;
  background: linear-gradient(
    180deg,
    rgba(234, 147, 46, 0) 28.89%,
    #ea932e 100%
  );
  border-radius: 18px;
}
.WhyMtor_MtorPriceWrapper__IJG0p {
  padding: 4px;
  background: linear-gradient(
    180deg,
    rgba(46, 153, 234, 0) 31.02%,
    #2e99ea 100%
  );
  border-radius: 18px;
}
.WhyMtor_MtorCommitmentWrapper__JotN0 {
  padding: 4px;
  border-radius: 18px;
  background: linear-gradient(
    180deg,
    rgba(50, 184, 53, 0) 0%,
    rgba(50, 184, 53, 0.195633) 69.24%,
    #32b835 100%
  );
}
`, "",{"version":3,"sources":["webpack://./src/components/Landing/WhyMtor/WhyMtor.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ;;;;GAIC;EACD,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ;;;;GAIC;EACD,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB;;;;;GAKC;AACH","sourcesContent":[".MtorQualityWrapper {\n  padding: 4px;\n  background: linear-gradient(\n    180deg,\n    rgba(234, 147, 46, 0) 28.89%,\n    #ea932e 100%\n  );\n  border-radius: 18px;\n}\n.MtorPriceWrapper {\n  padding: 4px;\n  background: linear-gradient(\n    180deg,\n    rgba(46, 153, 234, 0) 31.02%,\n    #2e99ea 100%\n  );\n  border-radius: 18px;\n}\n.MtorCommitmentWrapper {\n  padding: 4px;\n  border-radius: 18px;\n  background: linear-gradient(\n    180deg,\n    rgba(50, 184, 53, 0) 0%,\n    rgba(50, 184, 53, 0.195633) 69.24%,\n    #32b835 100%\n  );\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MtorQualityWrapper": `WhyMtor_MtorQualityWrapper__YS5NZ`,
	"MtorPriceWrapper": `WhyMtor_MtorPriceWrapper__IJG0p`,
	"MtorCommitmentWrapper": `WhyMtor_MtorCommitmentWrapper__JotN0`
};
export default ___CSS_LOADER_EXPORT___;
